module.exports = __webpack_public_path__ + "img/category-sport.2f38107f.png";